import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=c4cbb260&scoped=true"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=c4cbb260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cbb260",
  null
  
)

export default component.exports